// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-category-divider {
    height: 1px;
    width: 100%;
    background: #e1e1e1;
}

.select-group-option {
    font-size: 14px;
}

.select-group-label {
    padding: 0 16px;
}
`, "",{"version":3,"sources":["webpack://./client/components/product-collection/footer/components/left-side/manage-distribution-modal/components/select.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".select-category-divider {\n    height: 1px;\n    width: 100%;\n    background: #e1e1e1;\n}\n\n.select-group-option {\n    font-size: 14px;\n}\n\n.select-group-label {\n    padding: 0 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
